import React from "react";
import Styles from "./ExploreIraq.module.css";
import { useTranslation } from "react-i18next";

import exploreIraq from "../assets/Images/exploreIraq.png";
import GoToTop from "../components/GotoTop";

function ExploreIraq() {
	// for localization
	const { t } = useTranslation();

	return (
		<div className={Styles.container}>
			<GoToTop />
			<div className={Styles.padding}></div>
			<img
				className={Styles.img}
				src={exploreIraq}
				alt='Iraq Map'
			/>
			<h1 className={Styles.textPopUpTop}>
				{t("ExpolreIraq.coming")}
			</h1>
		</div>
	);
}

export default ExploreIraq;
